import PrivacyPage from "./PrivacyPage";

const page = PrivacyPage;
export default page;
